import React, { useState, useEffect } from "react";
import "./Budget.css";
import { useNavigate } from "react-router-dom";
import { db } from "../firebase";
import { collection, doc, query, where, getDocs, updateDoc, getDoc, orderBy } from "firebase/firestore";

window.budgetapproved = 0
const DEEPending = () => {
    const navigate = useNavigate();
    const [month, setMonth] = useState("");
    const [year, setYear] = useState("");
    const [actionPlan, setActionPlan] = useState([]);
    const [demands, setDemands] = useState({});
    const [budgetData, setBudgetData] = useState({
        ageneral: 0, ascsp: 0, acfld: 0, anicra: 0, aother: 0,
        ugeneral: 0, uscsp: 0, ucfld: 0, unicra: 0, uother: 0,
        bgeneral: 0, bscsp: 0, bcfld: 0, bnicra: 0, bother: 0,
    });
    const name = localStorage.getItem("empname");
    const empId = localStorage.getItem("empid");

    useEffect(() => {
        if (sessionStorage.getItem("login") !== "true") {
            navigate("/");
        }
    }, []);

    useEffect(() => {
        if (!month || !year) return;

const fetchActionPlan = async () => {
    try {
        const q = query(
            collection(db, "actionplan"),
            where("month", "==", String(month + " " + year)),
            orderBy("sshdate", "desc")
        );

        const querySnapshot = await getDocs(q);

        if (querySnapshot.empty) {
            setActionPlan([]);
            setDemands({});
            return;
        }

        const actions = [];
        const demandsObj = {};

        querySnapshot.forEach((doc) => {
            const data = doc.data();
            // Apply filter: only include documents where sshremarks is not empty
            if (data.sshremarks && data.sshremarks !== "") {
                const id = doc.id;

                const demandDate = data.demanddate?.toDate
                    ? data.demanddate.toDate().toLocaleDateString('en-GB')
                    : "N/A";
                const ddodate = data.ddodate && data.ddodate.toDate
                    ? data.ddodate.toDate().toLocaleDateString('en-GB')
                    : "N/A";
                const deedate = data.deedate && data.deedate.toDate
                    ? data.deedate.toDate().toLocaleDateString('en-GB')
                    : "N/A";

                actions.push({
                    id: id,
                    empid: data.empid || "",
                    supportdoc: data.supportdoc || "",
                    code: data.programCode || "",
                    text: data.program || "",
                    td: data.td || "",
                    totamount: data.totamount || "",
                    budgetApproved: data.budgetapproved || 0,
                    currentstatus: data.currentstatus || "Not Placed",
                    demanddate: demandDate,
                    budgetDemand: data.budgetdemand || "",
                    budgethead: data.budgethead || "",
                    ddodate: ddodate,
                    ddoremarks: data.ddoremarks || "",
                    deeremarks: data.deeremarks || "",
                    accremarks: data.accremarks || "",
                    kvk: data.kvk || "",
                    empname: data.empname || "",
                    empdesig: data.empdesig || "",
                    sshremarks: data.sshremarks || "" // Add sshremarks
                });

                demandsObj[id] = {
                    empid: data.empid || "",
                    td: data.td || "",
                    amount: data.budgetdemand || "",
                    totamount: data.totamount || "",
                    placed: !!data.budgetdemand,
                    currentstatus: data.currentstatus || "Not Placed",
                    demanddate: demandDate,
                    ddodate: ddodate,
                    deedate: deedate,
                    budgethead: data.budgethead || "",
                    ddoremarks: data.ddoremarks || "",
                    deeremarks: data.deeremarks || "",
                    accremarks: data.accremarks || "",
                    sshremarks: data.sshremarks || "" // Add sshremarks
                };
            }
        });

        setActionPlan(actions);
        setDemands(demandsObj);
    } catch (error) {
        console.error("Error fetching action plans:", error);
    }
};

        fetchActionPlan();
    }, [month, year]);

    const handleDemandPlace = async (id) => {
        const budgetText = demands[id]?.amount.trim();
        const totAmount = parseFloat(demands[id]?.totamount);

        if (!budgetText || isNaN(totAmount)) {
            alert("Please enter both budget demand and total amount before placing.");
            return;
        }

        try {
            const actionRef = doc(db, "actionplan", id);
            await updateDoc(actionRef, {
                budgetdemand: budgetText,
                totamount: totAmount,
                currentstatus: `Program and Budget Approved on ${new Date().toLocaleDateString('en-GB')}`,
                cs: 1,
                deedate: new Date(),
            });

            const updatedDemands = { ...demands };
            updatedDemands[id].placed = true;
            updatedDemands[id].currentstatus = `Program and Budget Approved on ${new Date().toLocaleDateString('en-GB')}`;
            updatedDemands[id].demanddate = new Date().toLocaleDateString("en-GB");
            setDemands(updatedDemands);
        } catch (error) {
            console.error("Error updating budget demand and totals:", error);
        }
    };
    function fy(month, year) {
        const y = parseInt(year);
        if (month === "January" || month === "February" || month === "March") {
            return String(y - 1 + "-" + y % 1000);
        } else {
            return String(y + "-" + parseInt(y % 1000 + 1));
        }
    }

    const handleApproveForward = async (id) => {
        console.log("demands[id]:", demands[id]);
        const deeremarks = demands[id]?.deeremarks.trim();
        const totAmount = parseFloat(demands[id]?.totamount);
        const budgetText = demands[id]?.amount.trim();

        if (!budgetText || isNaN(totAmount)) {
            alert("Please enter both budget demand and total amount before placing.");
            return;
        }
        if (!deeremarks) {
            alert("Please add DEE remarks before approving and forwarding.");
            return;
        }
        const budgetRef = doc(db, "empmaster", demands[id]?.empid, fy(month, year), "budget");
        const budgetDoc = await getDoc(budgetRef);
        if (budgetDoc.exists()) {
            const budgetData = budgetDoc.data();
            let updatedUtilized = 0;
            const budgetHead = demands[id]?.budgethead || actionPlan.find((action) => action.id === id)?.budgethead;

            switch (budgetHead) {
                case "General":
                    updatedUtilized = (budgetData.ugeneral || 0) + totAmount;
                    await updateDoc(budgetRef, { ugeneral: updatedUtilized });
                    setBudgetData((prev) => ({
                        ...prev,
                        ugeneral: updatedUtilized,
                    }));
                    break;

                case "SCSP":
                    updatedUtilized = (budgetData.uscsp || 0) + totAmount;
                    await updateDoc(budgetRef, { uscsp: updatedUtilized });
                    setBudgetData((prev) => ({
                        ...prev,
                        uscsp: updatedUtilized,
                    }));
                    break;

                case "CFLD Oilseed":
                    updatedUtilized = (budgetData.ucfldo || 0) + totAmount;
                    await updateDoc(budgetRef, { ucfldo: updatedUtilized });
                    setBudgetData((prev) => ({
                        ...prev,
                        ucfldo: updatedUtilized,
                    }));
                    break;

                case "CFLD Pulse":
                    updatedUtilized = (budgetData.ucfldp || 0) + totAmount;
                    await updateDoc(budgetRef, { ucfldp: updatedUtilized });
                    setBudgetData((prev) => ({
                        ...prev,
                        ucfldp: updatedUtilized,
                    }));
                    break;

                case "NICRA":
                    updatedUtilized = (budgetData.unicra || 0) + totAmount;
                    await updateDoc(budgetRef, { unicra: updatedUtilized });
                    setBudgetData((prev) => ({
                        ...prev,
                        unicra: updatedUtilized,
                    }));
                    break;

                case "Natural Farming":
                    updatedUtilized = (budgetData.unf || 0) + totAmount;
                    await updateDoc(budgetRef, { unf: updatedUtilized });
                    setBudgetData((prev) => ({
                        ...prev,
                        unf: updatedUtilized,
                    }));
                    break;

                case "Sponsored Program":
                    updatedUtilized = (budgetData.usponsored || 0) + totAmount;
                    await updateDoc(budgetRef, { usponsored: updatedUtilized });
                    setBudgetData((prev) => ({
                        ...prev,
                        usponsored: updatedUtilized,
                    }));
                    break;

                case "NABARD":
                    updatedUtilized = (budgetData.unabard || 0) + totAmount;
                    await updateDoc(budgetRef, { unabard: updatedUtilized });
                    setBudgetData((prev) => ({
                        ...prev,
                        unabard: updatedUtilized,
                    }));
                    break;

                case "ARYA":
                    updatedUtilized = (budgetData.uarya || 0) + totAmount;
                    await updateDoc(budgetRef, { uarya: updatedUtilized });
                    setBudgetData((prev) => ({
                        ...prev,
                        uarya: updatedUtilized,
                    }));
                    break;

                case "Oilseed Mission Village":
                    updatedUtilized = (budgetData.uosmv || 0) + totAmount;
                    await updateDoc(budgetRef, { uosmv: updatedUtilized });
                    setBudgetData((prev) => ({
                        ...prev,
                        uosmv: updatedUtilized,
                    }));
                    break;

                case "Seed Hub":
                    updatedUtilized = (budgetData.useedhub || 0) + totAmount;
                    await updateDoc(budgetRef, { useedhub: updatedUtilized });
                    setBudgetData((prev) => ({
                        ...prev,
                        useedhub: updatedUtilized,
                    }));
                    break;

                case "ATMA":
                    updatedUtilized = (budgetData.uatma || 0) + totAmount;
                    await updateDoc(budgetRef, { uatma: updatedUtilized });
                    setBudgetData((prev) => ({
                        ...prev,
                        uatma: updatedUtilized,
                    }));
                    break;

                case "Others":
                    updatedUtilized = (budgetData.uuniversity || 0) + totAmount;
                    await updateDoc(budgetRef, { uuniversity: updatedUtilized });
                    setBudgetData((prev) => ({
                        ...prev,
                        uuniversity: updatedUtilized,
                    }));
                    break;

                default:
                    console.error("Invalid budget head: " + budgetHead);
                    return;
            }
        }

        try {
            const actionRef = doc(db, "actionplan", id);
            await updateDoc(actionRef, {
                deeremarks: deeremarks,
                currentstatus: `Program and Budget Approved on ${new Date().toLocaleDateString('en-GB')}`,
                deedate: new Date(),
                cs: 1,
                budgetapproved: window.budgetapproved
            });

            const updatedDemands = { ...demands };
            updatedDemands[id].currentstatus = `Program and Budget Approved on ${new Date().toLocaleDateString('en-GB')}`;
            setDemands(updatedDemands);
        } catch (error) {
            console.error("Error Program and Budget Approved:", error);
        }
    };
  const handleBack =(e)=>{
    e.preventDefault();
    navigate(-1)
  }
    return (
        <div className="container">
            <h1 className="welcome">Seeking Approval of Director</h1>

            <div style={{ display: 'flex', flexDirection: 'row' }}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <label className="label">Select Month and Year:</label>
                    <select className="dropdown" id="dd1" value={month} onChange={(e) => setMonth(e.target.value)}>
                        <option value="">Month</option>
                        {["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"].map((m) => (
                            <option key={m} value={m}>{m}</option>
                        ))}
                    </select>
                </div>

                <select className="dropdown" id="dd2" value={year} onChange={(e) => setYear(e.target.value)} style={{ width: '150px', height: '40px', marginTop: '33px' }}>
                    <option value="">Year</option>
                    {["2025", "2026", "2027", "2028"].map((m) => (
                        <option key={m} value={m}>{m}</option>
                    ))}
                </select>
            </div>

            {actionPlan.length > 0 && (
                <div className="action-section">
                    <table className="action-table">
                        <thead>
                            <tr>
                                <th>KVK & Applicant</th>
                                <th>Budget Head</th>
                                <th>Program Code & Title/Subject</th>
                                <th>Supporting Document</th>
                                <th>Details of Notesheet</th>
                                <th>Accountant Remarks</th>
                                <th>DDO Remarks / DEE Remarks</th>
                            </tr>
                        </thead>
                        <tbody>
                            {actionPlan.map((action) => (
                                <tr key={action.id}>
                                    <td style={{fontSize: '14px'}}>{action.kvk} <br />{action.empname} <br /> {action.empdesig}</td>
                                    <td style={{fontSize: '14px'}}>{action.budgethead}</td>
                                    <td style={{fontSize: '14px', maxWidth: '100px'}}>{action.code} <br /> {action.text}</td>
                                    <td>
                                        {action.supportdoc ?
                                            <a href={action.supportdoc}  target="_blank"><button>View Document</button></a>
                                            : ""
                                        }
                                    </td>
                                    <td>
                                                                                <textarea
                                            rows="4"
                                            className="textarea-box"
                                            value={demands[action.id]?.td || ""}
                                            onChange={(e) => {
                                                const updatedDemands = { ...demands };
                                                updatedDemands[action.id].td = e.target.value;
                                                setDemands(updatedDemands);
                                            }}
                                            disabled={demands[action.id]?.placed}
                                        />
                                        <textarea
                                            rows="4"
                                            className="textarea-box"
                                            value={demands[action.id]?.amount || ""}
                                            onChange={(e) => {
                                                const updatedDemands = { ...demands };
                                                updatedDemands[action.id].amount = e.target.value;
                                                setDemands(updatedDemands);
                                            }}
                                            disabled={demands[action.id]?.placed}
                                        />
                                        <div hidden>
                                            {window.budgetapproved = demands[action.id]?.totamount}
                                        </div>
                                        <input
                                            type="number"
                                            placeholder="Enter Total Amount"
                                            value={demands[action.id]?.totamount || ""}
                                            onChange={(e) => {
                                                const updatedDemands = { ...demands };
                                                updatedDemands[action.id].totamount = e.target.value;
                                                setDemands(updatedDemands);
                                            }}
                                            disabled={demands[action.id]?.placed}
                                            className="textarea-box"
                                        />
                                        {!demands[action.id]?.placed && (
                                            <button className="place-btn full-width" onClick={() => handleDemandPlace(action.id)}>
                                                Place Demand
                                            </button>
                                        )}
                                        {demands[action.id]?.placed && (
                                            <h5 style={{ color: "green" }}>Demand Placed on {demands[action.id]?.demanddate}</h5>
                                        )}
                                    </td>
                                    <td>
                                        <textarea
                                            rows="4"
                                            className="textarea-box"
                                            value={demands[action.id]?.accremarks || ""}
                                            readOnly
                                        />
                                    </td>
                                    <td>
                                        {demands[action.id]?.placed && (
                                            <>
                                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                                    <textarea
                                                        disabled
                                                        rows="4"
                                                        placeholder="No DDO Remarks"
                                                        className="textarea-box"
                                                        value={demands[action.id]?.ddoremarks || ""}
                                                        style={{ width: '49%' }}
                                                    />
                                                    <textarea
                                                        rows="4"
                                                        placeholder="Enter DEE Remarks"
                                                        className="textarea-box"
                                                        value={demands[action.id]?.deeremarks || ""}
                                                        onChange={(e) => {
                                                            const updatedDemands = { ...demands };
                                                            updatedDemands[action.id].deeremarks = e.target.value;
                                                            setDemands(updatedDemands);
                                                        }}
                                                        style={{ width: '49%' }}
                                                    />
                                                </div>
                                                <br />
                                                <button disabled={demands[action.id]?.deeremarks.includes("Not Applicable") ? true : false} style={{ backgroundColor: 'lightblue', cursor: 'grab', height: '26px', border: 'none' }} className="approve-btn full-width" onClick={() => handleApproveForward(action.id)}>
                                                    Approve
                                                </button>
                                                <h5 style={{ color: "green" }}>{demands[action.id]?.currentstatus}</h5>
                                            </>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
                    <img src="/assets/back.png" style={{ width: '100px'}} onClick={handleBack} alt="" />

        </div>
    );
};

export default DEEPending;